<template>
  <div class="offlineList">
    <!-- 筛选 -->
    <div class="filters">
      <el-form :inline="true" label-suffix=":">
        <!-- 赛事名称input -->
        <el-form-item :label="$t('lang.lab_competeName')">
          <input style="display: none" />
          <el-input v-model="name" :placeholder="$t('lang.pla_pleaseInput') + $t('lang.lab_competeName')"></el-input>
        </el-form-item>
        <!-- 状态select -->
        <el-form-item :label="$t('lang.lab_competeStatus')">
          <el-select v-model="state" :placeholder="$t('lang.pla_pleaseSelect') + $t('lang.lab_competeStatus')">
            <el-option v-for="(item, index) in states" :key="index" :value="item.id" :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 查询 -->
        <el-button type="primary" @click="onSearch(true, true)">{{ $t('lang.btn_search') }}</el-button>
        <!-- 重置 -->
        <el-button type="primary" @click="onClear">{{ $t('lang.btn_reset') }}</el-button>
      </el-form>
    </div>
    <!-- 表格 -->
    <el-card>
      <!-- 新增 -->
      <el-button type="primary" slot="header" @click="onAdd">{{ $t('lang.btn_add') }}</el-button>
      <!-- 删除 -->
      <el-button type="primary" slot="header" @click="onDelete">{{ $t('lang.btn_delete') }}</el-button>
      <el-table class="wid100" :data="tableData" :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange" @sort-change="changeTableSort">
        <!-- 复选框 -->
        <el-table-column type="selection" align="center" width="55"></el-table-column>
        <!-- 赛事名称 -->
        <el-table-column prop="name" :label="$t('lang.lab_competeName')" :sortable="'custom'"
          width="300"></el-table-column>
        <!-- 状态 -->
        <el-table-column prop="competeStatusName" :label="$t('lang.lab_competeStatus')"
          :sortable="'custom'"></el-table-column>
        <!-- 场次 -->
        <el-table-column prop="numberOfCompeteNumber" :label="$t('lang.lab_sessions')" :sortable="'custom'">
          <template slot-scope="scope">
            <el-link type="primary" @click="linkSessions(scope.row.id)">{{ scope.row.numberOfCompeteNumber }}</el-link>
          </template>
        </el-table-column>
        <!-- 团队 -->
        <el-table-column prop="teamNum" :label="$t('lang.lab_teamManage')" :sortable="'custom'">
          <template slot-scope="scope">
            <el-link type="primary" @click="linkTeams(scope.row.id)">{{ scope.row.teamNum | valueIsNullToZero }}</el-link>
          </template>
        </el-table-column>
        <!-- 赛事项目 -->
        <el-table-column prop="numberOfCompeteItem" :label="$t('lang.lab_competeItem')" :sortable="'custom'">
          <template slot-scope="scope">
            <el-link type="primary" @click="linkProject(scope.row.id)">{{ scope.row.numberOfCompeteItem }}</el-link>
          </template>
        </el-table-column>
        <!-- 已报人次 -->
        <el-table-column prop="enrollNum" :label="$t('lang.lab_enrollNum')" :sortable="'custom'">
          <template slot-scope="scope">
            <el-link type="primary" @click="linkPlayer(scope.row)">{{ scope.row.enrollNum }}</el-link>
          </template>
        </el-table-column>
        <!-- 累计收费(元) -->
        <el-table-column prop="totalFee" :label="$t('lang.lab_totalFee')" :sortable="'custom'"></el-table-column>
        <!-- 操作 -->
        <el-table-column prop="operationn" :label="$t('lang.lab_operation')" fixed="right">
          <template slot-scope="scope">
            <el-button @click="onEdit(scope.row)">{{ $t('lang.btn_edit') }}</el-button>
            <el-button @click="onDetail(scope.row)">{{ $t('lang.btn_detail') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="total" />
    </el-card>
    <!-- 新增编辑查看 -->
    <el-dialog :title="isTitle" :visible.sync="isShow" :close-on-click-modal="false" :destroy-on-close="true" center
      top="130px" width="880px" v-if="isShow" @close="handleDialogClosed">
      <el-form :model="form" :rules="rules" ref="form" label-width="160px" label-suffix=":">
        <!-- 赛事名称 -->
        <el-form-item prop="name" :label="$t('lang.lab_competeName')">
          <input style="display: none" />
          <el-input v-model="form.name" :placeholder="$t('lang.pla_pleaseInput') + $t('lang.lab_competeName')"
            maxlength="20" :disabled="isCase === 2"></el-input>
        </el-form-item>
        <!-- 状态 -->
        <el-form-item prop="competeStatus" :label="$t('lang.lab_competeStatus')" v-if="isCase === 0">
          <el-select v-model="form.competeStatus" :placeholder="$t('lang.pla_pleaseSelect') + $t('lang.lab_competeStatus')"
            :disabled="isCase === 2">
            <el-option v-for="(item, index) in statesNew" :key="index" :value="item.id" :label="item.name"
              :disabled="item.disabled">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="competeStatus" :label="$t('lang.lab_competeStatus')" v-if="isCase !== 0">
          <el-select v-model="form.competeStatus" :placeholder="$t('lang.pla_pleaseSelect') + $t('lang.lab_competeStatus')"
            :disabled="isCase === 2">
            <el-option v-for="(item, index) in statesEdit" :key="index" :value="item.id" :label="item.name"
              :disabled="item.disabled">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 报名时间 -->
        <el-form-item prop="enrollTime" :label="$t('lang.lab_enrollTime')">
          <el-date-picker v-model="enrollValues" type="daterange" :clearable="false" :range-separator="$t('lang.lab_to')"
            :start-placeholder="$t('lang.lab_enrollTimeStart')" :end-placeholder="$t('lang.lab_enrollTimeEnd')"
            value-format="timestamp" :default-time="['00:00:00', '23:59:59']" :disabled="isCase === 2"
            :picker-options="pickerOptions0" @change="onPickEnroll"></el-date-picker>
        </el-form-item>
        <!-- 比赛时间 -->
        <el-form-item prop="raceTime" :label="$t('lang.lab_raceTime')">
          <el-date-picker v-model="raceValues" type="daterange" :clearable="false" :range-separator="$t('lang.lab_to')"
            :start-placeholder="$t('lang.lab_raceTimeStart')" :end-placeholder="$t('lang.lab_raceTimeEnd')"
            value-format="timestamp" :default-time="['00:00:00', '23:59:59']" :disabled="isCase === 2"
            :picker-options="pickerOptions1" @change="onPickRace"></el-date-picker>
        </el-form-item>
        <!-- 年龄判断基准 -->
        <el-form-item prop="ageStandard" :label="$t('lang.lab_ageStandard')">
          <el-date-picker :disabled="isCase === 2" v-model="form.ageStandard" type="date" value-format="timestamp"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <!-- 收费方式 -->
        <el-form-item prop="paymentMethod" :label="$t('lang.lab_chargeMethod')">
          <el-radio-group v-model="form.paymentMethod">
            <el-radio :label=0 :disabled="isCase === 2">{{ $t('lang.lab_chargePerItem') }}</el-radio>
            <el-radio :label=1 :disabled="isCase === 2">{{ $t('lang.lab_perPersonCharge') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 单人单项费用 -->
        <el-form-item prop="singleFee"
          :label="form.paymentMethod == 0 ? $t('lang.lab_singleFee') : $t('lang.lab_singlePerFee')">
          <input style="display: none" />
          <el-input v-model="form.singleFee"
            :placeholder="form.paymentMethod == 0 ? $t('lang.pla_pleaseInput') + $t('lang.lab_singleFee') : $t('lang.pla_pleaseInput') + $t('lang.lab_singlePerFee')"
            maxlength="7" @input="keySingleFee" :disabled="isCase === 2"></el-input>
        </el-form-item>
        <!-- 用户创建团队 -->
        <el-form-item prop="userCreatesTeam" :label="$t('lang.lab_creatTeam')">
          <el-radio-group v-model="form.userCreatesTeam">
            <el-radio :label=0 :disabled="isCase === 2">{{ $t('lang.lab_creatTeamPermit') }}</el-radio>
            <el-radio :label=1 :disabled="isCase === 2">{{ $t('lang.lab_creatTeamForbid') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 报名选择团队 -->
        <el-form-item prop="signUpAndChooseTeam" :label="$t('lang.lab_signUpAndChooseTeam')">
          <el-radio-group v-model="form.signUpAndChooseTeam">
            <el-radio :label=0 :disabled="isCase === 2">{{ $t('lang.lab_signUpAndChooseTeamRequired') }}</el-radio>
            <el-radio :label=1 :disabled="isCase === 2">{{ $t('lang.lab_signUpAndChooseTeamUnRequired') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 团队报名人数限制 -->
        <el-form-item prop="teamEnrollLimit" :label="$t('lang.lab_teamEnrollLimit')">
          <el-row>
            <el-col :span="10"><input style="display: none" /><el-input v-model="form.teamEnrollLowLimit"
                :placeholder="$t('lang.pla_pleaseInput') + $t('lang.lab_teamEnrollLowLimit')" maxlength="4"
                @input="keyTeamLow" :disabled="isCase === 2"></el-input></el-col>
            <el-col :span="4">
              <div class="center-style"><span>——</span></div>
            </el-col>
            <el-col :span="10"><input style="display: none" /><el-input v-model="form.teamEnrollUpLimit"
                :placeholder="$t('lang.pla_pleaseInput') + $t('lang.lab_teamEnrollUpLimit')" maxlength="4"
                @input="keyTeamHigh" :disabled="isCase === 2"></el-input></el-col>
          </el-row>
        </el-form-item>
        <!-- 单人报名项目上限 -->
        <el-form-item prop="singleEnrollItemLimit" :label="$t('lang.lab_singleEnrollItemLimit')">
          <input style="display: none" />
          <el-input v-model="form.singleEnrollItemLimit"
            :placeholder="$t('lang.pla_pleaseInput') + $t('lang.lab_singleEnrollItemLimit')" maxlength="2"
            @input="keySingleEnroll" :disabled="isCase === 2"></el-input>
        </el-form-item>
        <!-- 赛事封面 -->
        <el-form-item prop="imgUrl" ref="imgUrl" :label="$t('lang.lab_competeImg')" v-if="isCase !== 2">
          <el-upload :before-upload="beforeAvatarUpload" :class="{ imgUrlDisabled: imgUrlMax }" accept=".jpg,.jpeg,.png"
            :on-success="handleSuccessImg" :on-remove="handleRemoveImg" :on-exceed="outlimit" :on-error="uploadErr"
            :limit="1" name="files" :action="require('@/config/enum').actionname" list-type="picture-card"
            :file-list="imgUrlList">
            <el-button size="small" type="primary">{{ $t('lang.btn_upload') }}</el-button>
            <div class="el-upload__tip" slot="tip">{{ $t('lang.tip_upload_img') }}</div>
          </el-upload>
        </el-form-item>
        <el-form-item prop="imgUrl2" :label="$t('lang.lab_competeImg')" v-if="isCase === 2">
          <viewer :images="imgUrlArray">
            <img :src="this.form.imgUrl" class="img-style" />
          </viewer>
        </el-form-item>
        <!-- 赛事规程 -->
        <el-form-item prop="ruleUrlList" ref="ruleUrlList" :label="$t('lang.lab_competeRule')" v-if="isCase !== 2">
          <el-upload :before-upload="beforeAvatarUpload" :class="{ ruleUrlsDisabled: ruleUrlsMax }" accept=".jpg,.jpeg,.png"
            :on-success="handleSuccessRule" :on-remove="handleRemoveRule" :on-exceed="outlimit" :on-error="uploadErr"
            :limit="9" name="files" :action="require('@/config/enum').actionname" list-type="picture-card"
            :file-list="ruleUrlsList">
            <el-button size="small" type="primary">{{ $t('lang.btn_upload') }}</el-button>
            <div class="el-upload__tip" slot="tip">{{ $t('lang.tip_upload1') }}</div>
          </el-upload>
        </el-form-item>
        <el-form-item prop="ruleUrlList2" :label="$t('lang.lab_competeRule')" v-if="isCase === 2">
          <viewer :images="this.form.ruleUrlList">
            <img v-for="(src, index) in this.form.ruleUrlList" :src="src" :key="index" class="img-style-mini" />
          </viewer>
        </el-form-item>
        <!-- 赛事项目 -->
        <el-form-item prop='competeItemDtoList' ref='competeItemDtoList' :label="$t('lang.lab_competeItem')">
          <el-form :rules="cRules" :model="form" ref="cForm" v-if="hasItem === true">
            <el-table :data="form.competeItemDtoList" border class="table-position" v-if="hasItem === true">
              <!-- 序号 -->
              <el-table-column label="#" type="index" align="center" width="50"></el-table-column>
              <!-- 赛事项目名称 -->
              <el-table-column prop="itemName" :label="$t('lang.lab_competeItemName')" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.itemName }}</span>
                  <el-button class="deleteBtn-style" icon="el-icon-close" @click="deleteOne(scope.row)"
                    v-if="isCase !== 2 && (scope.row.enrollNum < 1 || scope.row.enrollNum === null)"></el-button>
                </template>
              </el-table-column>
              <!-- 报名上限 -->
              <el-table-column prop="enrollLimit" :label="$t('lang.lab_enrollLimit')" align="center" width="120">
                <template slot-scope="scope">
                  <template v-if="isCase !== 2">
                    <el-form-item :prop="'competeItemDtoList.' + scope.$index + '.enrollLimit'"
                      :rules="cRules.enrollLimit">
                      <el-input @input="keyEnrollLimit" v-model="scope.row.enrollLimit"
                        :placeholder="$t('lang.lab_enrollLimit')" maxlength="5"></el-input>
                    </el-form-item>
                  </template>
                  <template v-else>
                    <span>{{ scope.row.enrollLimit | valueIsNullToZero }}</span>
                  </template>
                </template>
              </el-table-column>
              <!-- 已报人数 -->
              <el-table-column prop="enrollNum" :label="$t('lang.lab_enrollNums')" align="center" width="120">
                <template slot-scope="scope">
                  <span>{{ scope.row.enrollNum | valueIsNullToZero }}</span>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
          <!-- 点击进入赛事项目列表 -->
          <el-button class="margin-t10" type="primary" @click="toAddCompeteItem()" v-if="isCase !== 2">{{
            this.textAddCompeteItem }}</el-button>
        </el-form-item>
        <!-- 证书背景 -->
        <el-form-item prop="certificateBackgroundUrl" ref="certificateBackgroundUrl" :label="$t('lang.lab_certificateBg')"
          v-if="isCase !== 2">
          <el-upload :before-upload="beforeAvatarUpload" :class="{ bgUrlDisabled: bgUrlMax }" accept=".jpg,.jpeg,.png"
            :on-success="handleSuccessBg" :on-remove="handleRemoveBg" :on-exceed="outlimit" :on-error="uploadErr"
            :limit="1" name="files" :action="require('@/config/enum').actionname" list-type="picture-card"
            :file-list="backgroundUrlList">
            <el-button size="small" type="primary">{{ $t('lang.btn_upload') }}</el-button>
            <div class="el-upload__tip" slot="tip">{{ $t('lang.tip_upload1') }}</div>
          </el-upload>
        </el-form-item>
        <el-form-item prop="certificateBackgroundUrl2" :label="$t('lang.lab_certificateBg')" v-if="isCase === 2">
          <viewer :images="backgroundUrlArray">
            <img :src="form.certificateBackgroundUrl" class="img-style" />
          </viewer>
        </el-form-item>
        <!-- 群聊二维码 -->
        <el-form-item prop="groupChatCode" ref="groupChatCode" :label="$t('lang.lab_groupChatCode')" v-if="isCase !== 2">
          <el-upload :before-upload="beforeAvatarUpload" :class="{ codeUrlDisabled: codeUrlMax }" accept=".jpg,.jpeg,.png"
            :on-success="handleSuccessCode" :on-remove="handleRemoveCode" :on-exceed="outlimit" :on-error="uploadErr"
            :limit="1" name="files" :action="require('@/config/enum').actionname" list-type="picture-card"
            :file-list="groupChatCodeList">
            <el-button size="small" type="primary">{{ $t('lang.btn_upload') }}</el-button>
            <div class="el-upload__tip" slot="tip">{{ $t('lang.tip_upload1') }}</div>
          </el-upload>
        </el-form-item>
        <el-form-item prop="groupChatCode2" :label="$t('lang.lab_groupChatCode')" v-if="isCase === 2&&form.groupChatCode">
          <viewer :images="groupChatCodeList">
            <img :src="form.groupChatCode" class="img-style" />
          </viewer>
        </el-form-item>
      </el-form>
      <div slot="footer" v-if="isCase !== 2">
        <el-button @click="toCancel">{{ $t('lang.btn_cancel') }}</el-button>
        <el-button type="primary" @click="toSave('form', 'cForm')"
          :disabled="isTotal === 0">{{ $t('lang.btn_confirm') }}</el-button>
      </div>
    </el-dialog>
    <!-- 赛事项目 -->
    <el-dialog class="dialog-style" :title="$t('lang.lab_addCompeteItem')" :visible.sync="isShowCI"
      :close-on-click-modal="false" :destroy-on-close="true" center top="130px" width="880px" v-if="isShowCI"
      @close="handleDialogClosedCI">
      <!-- 筛选 -->
      <div class="filtersCI">
        <el-form :inline="true" label-suffix=":">
          <!-- 赛事项目input -->
          <el-form-item :label="$t('lang.lab_competeItem')">
            <input style="display: none" />
            <el-input v-model="itemName" :placeholder="$t('lang.pla_pleaseInput') + $t('lang.lab_competeItem')"></el-input>
          </el-form-item>
          <!-- 比赛项select -->
          <el-form-item :label="$t('lang.lab_competeEvent')">
            <el-select multiple v-model="eventId" :placeholder="$t('lang.pla_pleaseSelect') + $t('lang.lab_competeEvent')"
              class="event-select">
              <el-option v-for="(item, index) in eventNames" :key="index" :value="item.id" :label="item.eventName">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 组别select -->
          <el-form-item :label="$t('lang.lab_competeGroup')">
            <el-select multiple v-model="groupId" :placeholder="$t('lang.pla_pleaseSelect') + $t('lang.lab_competeGroup')">
              <el-option v-for="(item, index) in groupNames" :key="index" :value="item.id" :label="item.groupName">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 年龄段select -->
          <el-form-item :label="$t('lang.lab_competeAgeGroup')">
            <el-select multiple v-model="ageGroupId"
              :placeholder="$t('lang.pla_pleaseSelect') + $t('lang.lab_competeAgeGroup')">
              <el-option v-for="(item, index) in ageNames" :key="index" :value="item.id" :label="item.ageGroupName">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 查询 -->
          <el-button type="primary" @click="onSearchCI(true, true)">{{ $t('lang.btn_search') }}</el-button>
          <!-- 重置 -->
          <el-button type="primary" @click="onClearCI">{{ $t('lang.btn_reset') }}</el-button>
        </el-form>
      </div>
      <!-- 表格 -->
      <el-card>
        <el-table ref="multipleTableCI" class="wid100" :data="tableDataCI" :row-key="getRowKey"
          :row-class-name="tableRowClassName" @selection-change="handleSelectionChangeCI" @select="handleSelectionCI"
          @select-all="handleSelectAllCI" @sort-change="changeTableSortCI">
          <!-- 复选框 -->
          <el-table-column type="selection" align="center" width="55"></el-table-column>
          <!-- 赛事项目 -->
          <el-table-column prop="itemName" :label="$t('lang.lab_competeItem')" :sortable="'custom'"></el-table-column>
          <!-- 赛事类别 -->
          <el-table-column prop="competeCategoryName" :label="$t('lang.lab_competeCategory')"
            :sortable="'custom'"></el-table-column>
          <!-- 比赛项 -->
          <el-table-column prop="itemEventName" :label="$t('lang.lab_competeEvent')"
            :sortable="'custom'"></el-table-column>
          <!-- 组别 -->
          <el-table-column prop="itemGroupName" :label="$t('lang.lab_competeGroup')"
            :sortable="'custom'"></el-table-column>
          <!-- 年龄段 -->
          <el-table-column prop="itemAgeName" :label="$t('lang.lab_competeAgeGroup')"
            :sortable="'custom'"></el-table-column>
        </el-table>
        <!-- 确定更新到赛事 -->
        <el-button class="confirmBtn-style" type="primary"
          @click="onConfirmCI">{{ $t('lang.btn_confirmToCompete') }}</el-button>
        <!-- 分页 -->
        <el-pagination @size-change="handleSizeChangeCI" @current-change="handleCurrentChangeCI" :current-page="pageNumCI"
          :page-sizes="[10, 20, 30, 50]" :page-size="pageSizeCI" layout="total, sizes, prev, pager, next, jumper"
          :total="totalCI" />
      </el-card>
    </el-dialog>
  </div>
</template>

<script>
/**
 *@ClassName:offlineList
 *@Description:线下赛管理
 *@author:宋莎
 *@Copyright:美再晨
 *@date:2020-07-11
 */

export default {
  name: '',
  components: {},
  data() {
    // 团队报名人数限制
    var teamEnrollLimitCheck = (rule, value, callback) => {
      console.log('teamEnrollLimitCheck', this.form.teamEnrollLowLimit, this.form.teamEnrollLowLimit)
      if (this.form.teamEnrollLowLimit === '' && this.form.teamEnrollLowLimit === '') {
        callback(new Error(this.$i18n.t('lang.warning_teamEnrollLimit')))
      } else if (this.form.teamEnrollLowLimit === '') {
        callback(new Error(this.$i18n.t('lang.warning_teamEnrollLowLimit')))
      } else if (Number(this.form.teamEnrollLowLimit) < 1) {
        callback(new Error(this.$i18n.t('lang.warning_teamEnrollMin')))
      } else if (this.form.teamEnrollUpLimit === '') {
        callback(new Error(this.$i18n.t('lang.warning_teamEnrollUpLimit')))
      } else if (Number(this.form.teamEnrollUpLimit) < Number(this.form.teamEnrollLowLimit)) {
        callback(new Error(this.$i18n.t('lang.warning_teamEnrollLowUp')))
      } else {
        callback()
      }
    }
    // 报名时间
    var enrollTimeCheck = (rule, value, callback) => {
      console.log('enrollTimeCheck', this.enrollValues)
      if (this.enrollValues === null) {
        callback(new Error(this.$i18n.t('lang.warning_enrollTime')))
      } else if (this.enrollValues.length === 0) {
        callback(new Error(this.$i18n.t('lang.warning_enrollTime')))
      } else {
        callback()
      }
    }
    // 比赛时间
    var raceTimeCheck = (rule, value, callback) => {
      console.log('raceTimeCheck', this.raceValues)
      if (this.raceValues === null) {
        callback(new Error(this.$i18n.t('lang.warning_raceTime')))
      } else if (this.raceValues.length === 0) {
        callback(new Error(this.$i18n.t('lang.warning_raceTime')))
      } else if (this.raceValues[0] < this.enrollValues[1]) {
        callback(new Error(this.$i18n.t('lang.warning_startTime')))
      } else {
        callback()
      }
    }
    // 年龄限制
    var ageStandardCheck = (rule, value, callback) => {
      if (this.form.ageStandard === null) {
        callback(new Error(this.$i18n.t('lang.warning_ageStandard')))
      } else if (this.form.ageStandard.length === 0) {
        callback(new Error(this.$i18n.t('lang.warning_ageStandard')))
      } else {
        callback()
      }
    }
    // 赛事项目报名上线
    var enrollLimitCheck = (rule, value, callback) => {
      console.log('enrollLimitCheck', rule.field, value)
      var str = rule.field.toString()
      str = str.replace('competeItemDtoList.', '')
      str = str.replace('.enrollLimit', '')
      let a = Number(str)
      console.log('str', str, this.form.competeItemDtoList[a].enrollNum)
      if (value === '' || value === null) {
        callback(new Error(this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_enrollLimit')))
      } else if (value < this.form.competeItemDtoList[a].enrollNum) {
        callback(new Error(this.$i18n.t('lang.warning_enrollLimit')))
      } else {
        callback()
      }
    }
    // 单人单项费用
    var singleFeeCheck = (rule, value, callback) => {
      console.log('singleFeeCheck')
      if (value === '') {
        // 如果单人单项
        if (this.form.paymentMethod == 0) {
          callback(new Error(this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_singleFee1')))
        } else {
          callback(new Error(this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_singlePerFee1')))
        }
      } else if (value === 0 || value === '0.0' || value === '0.00') {
        callback(new Error(this.$i18n.t('lang.warning_singleFee')))
      } else {
        callback()
      }
    }
    return {
      imgUrlMax: false, // 是否达到赛事封面个数上限
      ruleUrlsMax: false, // 是否达到赛事规程个数上限
      bgUrlMax: false, // 是否达到证书背景个数上限
      codeUrlMax: false, // 是否达到群聊二维码个数上限
      textAddCompeteItem: this.$i18n.t('lang.btn_addCompeteItem'), // 详情-赛事项目按钮显示文字
      isShow: false, // 新增编辑查看dialog的显示控制
      isTitle: this.$i18n.t('lang.btn_add'), // 新增编辑查看dialog的title
      isShowCI: false, // 赛事项目列表dialog的显示控制
      isCase: 0, // 当前状态：0新增 1编辑 2查看
      hasItem: false, // 详情-赛事项目列表为空时不显示(false)
      /* 确定按钮可点击 */
      isDisabled_form: 0, // form数据
      isDisabled_enrollValues: 0, // 报名时间
      isDisabled_raceValues: 0, // 比赛时间
      isDisabled_competeList: 0, // 赛事项目
      /* 线下赛列表变量 */
      multipleSelection: [], // 复选框
      pageNum: 1, // 页数
      pageSize: 10, // 每页显示数量
      total: 0, // 数据总数
      states: this.$i18n.t('lang.Offline_states'), // 状态下拉list
      statesNew: this.$i18n.t('lang.Offline_statesNew'), // 新建 状态下拉list
      statesEdit: this.$i18n.t('lang.Offline_statesEdit'), // 编辑 状态下拉list
      state: '', // 筛选-状态
      name: '', // 筛选-赛事名称
      sortName: '', // 升序/降序
      sortFieldName: '', // 排序字段
      tableData: [], // 线下赛列表数据
      /* 记忆筛选项值 */
      state_bak: '', // 备份-状态
      name_bak: '', // 备份-赛事名称
      /* 线下赛详情(新建编辑查看)变量 */
      rules: {
        name: [{ required: true, message: this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_competeName'), trigger: 'blur' }],
        competeStatus: [{ required: true, message: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_competeStatus'), trigger: 'change' }],
        enrollTime: [{ required: true, validator: enrollTimeCheck, trigger: 'change' }],
        userCreatesTeam: [{ required: true, message: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_creatTeam'), trigger: 'change' }],
        paymentMethod: [{ required: true, message: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_chargeMethod'), trigger: 'change' }],
        signUpAndChooseTeam: [{ required: true, message: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_signUpAndChooseTeam'), trigger: 'change' }],
        raceTime: [{ required: true, validator: raceTimeCheck, trigger: 'change' }],
        ageStandard: [{ required: true, validator: ageStandardCheck, trigger: 'change' }],
        singleFee: [{ required: true, validator: singleFeeCheck, trigger: 'blur' }],
        teamEnrollLimit: [{ required: true, validator: teamEnrollLimitCheck, trigger: 'blur' }],
        singleEnrollItemLimit: [{ required: true, message: this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_singleEnrollItemLimit'), trigger: 'blur' }],
        imgUrl: [{ required: true, message: this.$i18n.t('lang.pla_pleaseUpload') + this.$i18n.t('lang.lab_competeImg'), trigger: 'change' }],
        imgUrl2: [{ required: true, message: this.$i18n.t('lang.pla_pleaseUpload') + this.$i18n.t('lang.lab_competeImg'), trigger: 'change' }],
        ruleUrlList: [{ required: true, message: this.$i18n.t('lang.pla_pleaseUpload') + this.$i18n.t('lang.lab_competeRule'), trigger: 'change' }],
        ruleUrlList2: [{ required: true, message: this.$i18n.t('lang.pla_pleaseUpload') + this.$i18n.t('lang.lab_competeRule'), trigger: 'change' }],
        competeItemDtoList: [{ required: true, message: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_competeItem'), trigger: 'change' }],
        certificateBackgroundUrl: [{ required: true, message: this.$i18n.t('lang.pla_pleaseUpload') + this.$i18n.t('lang.lab_certificateBg'), trigger: 'change' }],
        certificateBackgroundUrl2: [{ required: true, message: this.$i18n.t('lang.pla_pleaseUpload') + this.$i18n.t('lang.lab_certificateBg'), trigger: 'change' }],
        groupChatCode: [{ message: this.$i18n.t('lang.pla_pleaseUpload') + this.$i18n.t('lang.lab_groupChatCode'), trigger: 'change' }],
        groupChatCode2: [{ message: this.$i18n.t('lang.pla_pleaseUpload') + this.$i18n.t('lang.lab_groupChatCode'), trigger: 'change' }],
      },
      enrollValues: [], // 报名开始结束时间的绑定值
      raceValues: [], // 比赛开结束时间的绑定值
      imgUrlList: [], // 赛事封面上传
      ruleUrlsList: [], // 赛事规程上传
      backgroundUrlList: [], // 证书背景上传
      groupChatCodeList: [], // 群聊二维码上传
      imgUrlArray: [], // 赛事封面viewer绑定值
      ruleUrlArray: [], // 赛事规程viewer绑定值
      backgroundUrlArray: [], // 证书背景viewer绑定值
      form: {
        id: '',
        type: 0,
        name: '',
        ageStandard: '',
        userCreatesTeam: 0, // 0.允许、1.禁止。单选，默认允许
        paymentMethod: 0, // 收费方式：0按项目收费 ,1按人收费。单选，默认按项目收费
        signUpAndChooseTeam: 1, // 0.必选、1.非必选。单选，默认非必选"
        competeStatus: '',
        competeStatusName: '',
        startTime: '',
        endTime: '',
        enrollStartTime: '',
        enrollEndTime: '',
        singleFee: '',
        teamEnrollLowLimit: '',
        teamEnrollUpLimit: '',
        singleEnrollItemLimit: '',
        competeItemDtoList: [],
        imgUrl: '',
        ruleUrlList: [],
        certificateBackgroundUrl: '',
        groupChatCode: ''// 群聊二维码
      }, // 详细数据
      cRules: {
        enrollLimit: [{ required: true, validator: enrollLimitCheck, trigger: 'blur' }],
      },
      form_competeItemDtoList_bak: [], // 初始备份 编辑-赛事项目数据
      form_competeItemDtoList_variable: [], // 变量备份 编辑-赛事项目数据
      /* 赛事项目列表变量 */
      multipleSelectionCI: [], // 复选框
      pageNumCI: 1, // 页数
      pageSizeCI: 10, // 每页显示数量
      totalCI: 0, // 数据总数
      eventNames: [], // 比赛项下拉list
      ageNames: [], // 年龄段下拉list
      groupNames: [], // 组别下拉list
      itemName: '', // 筛选-赛事项目
      eventId: [], // 筛选-比赛项
      ageGroupId: [], // 筛选-年龄段
      groupId: [], // 筛选-组别
      sortNameCI: '', // 升序/降序
      sortFieldNameCI: '', // 排序字段
      tableDataCI: [], // 赛事项目列表数据
      /* 记忆筛选项值 */
      itemName_bak: '', // 备份-赛事项目
      eventId_bak: [], // 备份-比赛项
      groupId_bak: [], // 备份-年龄段
      ageGroupId_bak: [], // 备份-组别
      /* 日期只能选择今天及之后的 */
      enrollEndTime: '',
      startTime: '',
      pickerOptions0: {
        disabledDate: (time) => {
          return time.getTime() > new Date(this.startTime).getTime() - 2.88e7 - 1
        }
      },
      pickerOptions1: {
        disabledDate: (time) => {
          return time.getTime() < new Date(this.enrollEndTime).getTime() - 2.88e7 + 8.64e7
        }
      },
      // 存储筛选值和页码
      offlineState: {
        pageNum: 1,
        pageSize: 10,
        state: '',
        name: '',
        sortName: '',
        sortFieldName: '',
      },
      // defaultSort: {
      //   prop: '', // 排序的属性
      //   order: '' // 排序方向：升序或降序
      // }
    }
  },
  computed: {
    isTotal: function () {
      console.log('isDisabled:', this.isDisabled_form, this.isDisabled_enrollValues, this.isDisabled_raceValues)
      return this.isDisabled_form + this.isDisabled_enrollValues + this.isDisabled_raceValues
    }
  },
  watch: {
    form: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData_form) {
          // 没变
          this.isDisabled_form = 0
        } else {
          // 变了
          this.isDisabled_form = 1
        }
      },
      deep: true,
      immediate: true
    },
    enrollValues: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData_enrollValues) {
          // 没变
          this.isDisabled_enrollValues = 0
        } else {
          // 变了
          this.isDisabled_enrollValues = 1
        }
      },
      deep: true,
      immediate: true
    },
    raceValues: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData_raceValues) {
          // 没变
          this.isDisabled_raceValues = 0
        } else {
          // 变了
          this.isDisabled_raceValues = 1
        }
      },
      deep: true,
      immediate: true
    },
  },
  methods: {
    beforeAvatarUpload(file) {
      if (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png') {

      } else {
        this.$message.error(this.$i18n.t('lang.tip_upload1'))
        return false
      }
    },
    // 赋值存储
    setDataLoacal() {
      this.offlineState.pageNum = this.pageNum
      this.offlineState.pageSize = this.pageSize
      this.offlineState.state = this.state
      this.offlineState.name = this.name
      this.offlineState.sortName = this.sortName
      this.offlineState.sortFieldName = this.sortFieldName
      // 点击搜索存储搜索内容，用于不刷新时默认展示-退出登录等页面功能均已清除全部缓存，不需要额外清除此缓存
      window.localStorage.setItem('offlineState', JSON.stringify(this.offlineState))
    },
    // 获取线下赛列表数据
    getData() {
      // 原刷新逻辑代码
      // this.$get(`/compete/filterCompete?type=0&pageNum=${this.pageNum}&pageSize=${this.pageSize}`).then(
      //   res => {
      //     if (res && res.code === 200) {
      //       this.total = res.data.total
      //       this.tableData = res.data.list
      //     } else {
      //       this.$message.error(res.message)
      //     }
      //   },
      //   error => {
      //     this.$message.error(error)
      //   }
      // )
      // 修改部分条件下不刷新页面，保留筛选数据：取localStorage数据
      this.state = ((window.localStorage.getItem('offlineState') && JSON.parse(window.localStorage.getItem('offlineState')).state) || (window.localStorage.getItem('offlineState') && JSON.parse(window.localStorage.getItem('offlineState')).state == 0)) ? JSON.parse(window.localStorage.getItem('offlineState')).state : ''
      this.state_bak = this.state
      this.name = window.localStorage.getItem('offlineState') && JSON.parse(window.localStorage.getItem('offlineState')).name ? JSON.parse(window.localStorage.getItem('offlineState')).name : ''
      this.name_bak = this.name
      this.sortName = window.localStorage.getItem('offlineState') && JSON.parse(window.localStorage.getItem('offlineState')).sortName ? JSON.parse(window.localStorage.getItem('offlineState')).sortName : ''
      this.sortFieldName = window.localStorage.getItem('offlineState') && JSON.parse(window.localStorage.getItem('offlineState')).sortFieldName ? JSON.parse(window.localStorage.getItem('offlineState')).sortFieldName : ''
      // this.defaultSort.prop = this.sortFieldName 
      // this.defaultSort.order = this.sortName
      this.pageNum = window.localStorage.getItem('offlineState') && JSON.parse(window.localStorage.getItem('offlineState')).pageNum ? JSON.parse(window.localStorage.getItem('offlineState')).pageNum : 1
      this.pageSize = window.localStorage.getItem('offlineState') && JSON.parse(window.localStorage.getItem('offlineState')).pageSize ? JSON.parse(window.localStorage.getItem('offlineState')).pageSize : 10
      this.$get(`/compete/filterCompete?type=0&competeStatus=${this.state}&name=${this.name}&sortName=${this.sortName}&sortFieldName=${this.sortFieldName}&pageNum=${this.pageNum}&pageSize=${this.pageSize}`).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 查询
    onSearch(flag, isSearch) {
      if (flag) {
        this.pageNum = 1
      }
      this.setDataLoacal()
      if (isSearch) {
        // 记忆筛选项值
        this.state_bak = this.state
        this.name_bak = this.name
      } else {
        // 筛选项正确显示
        this.state = this.state_bak
        this.name = this.name_bak
      }
      this.$get(`/compete/filterCompete?type=0&competeStatus=${this.state}&name=${this.name}&sortName=${this.sortName}&sortFieldName=${this.sortFieldName}&pageNum=${this.pageNum}&pageSize=${this.pageSize}`).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 重置
    onClear() {
      this.name = ''
      this.state = ''
      this.name_bak = ''
      this.state_bak = ''
      this.pageNum = 1
      this.sortName = ''
      this.sortFieldName = ''
      this.setDataLoacal()
      this.getData()
    },
    // 新增
    onAdd() {
      console.log('onAdd')
      this.pageNumCI = 1
      this.pageSizeCI = 10
      this.isTitle = this.$i18n.t('lang.btn_add')
      this.hasItem = false
      this.imgUrlMax = false
      this.ruleUrlsMax = false
      this.bgUrlMax = false
      this.codeUrlMax = false
      this.isCase = 0
      this.form.id = ''
      this.form.type = 0
      this.form.name = ''
      this.form.competeStatus = ''
      this.form.ageStandard = ''
      this.form.competeStatusName = ''
      this.form.userCreatesTeam = 0
      this.form.paymentMethod = 0
      this.form.signUpAndChooseTeam = 1
      this.form.startTime = ''
      this.form.endTime = ''
      this.form.enrollStartTime = ''
      this.form.enrollEndTime = ''
      this.startTime = ''
      this.enrollEndTime = ''
      this.form.singleFee = ''
      this.form.teamEnrollLowLimit = ''
      this.form.teamEnrollUpLimit = ''
      this.form.singleEnrollItemLimit = ''
      this.form.competeItemDtoList = []
      this.form.imgUrl = ''
      this.form.ruleUrlList = []
      this.form.certificateBackgroundUrl = ''
      this.form.groupChatCode = ''
      this.form_competeItemDtoList_bak = []
      this.form_competeItemDtoList_variable = []
      this.enrollValues = []
      this.raceValues = []
      this.imgUrlList = []
      this.ruleUrlsList = []
      this.backgroundUrlList = []
      this.textAddCompeteItem = this.$i18n.t('lang.btn_addCompeteItem')
      this.isShow = true
    },
    // 删除
    onDelete() {
      console.log('onDelete')
      var array = []
      for (let index = 0; index < this.multipleSelection.length; index++) {
        array.push(this.multipleSelection[index].id)
      }
      if (array.length === 0) {
        this.$message.error(this.$i18n.t('lang.warning_selectOneDelete'))
        return
      }
      let loading = this.$loading()
      this.$confirm(this.$i18n.t('lang.lab_isDelete'), this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
        this.$delete(`/compete/compete/${array}`).then(
          res => {
            loading.close()
            if (res && res.code === 200) {
              this.$message({
                type: 'success',
                message: this.$i18n.t('lang.lab_delSuccess')
              })
              // 更新tableData
              this.onSearch(true, false)
            } else {
              this.$message.error(res.message)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_delCancel')
          })
        })
    },
    // 编辑
    onEdit(data) {
      console.log('onEdit', data)
      this.pageNumCI = 1
      this.pageSizeCI = 10
      this.isTitle = this.$i18n.t('lang.btn_edit')
      this.isCase = 1
      this.codeUrlMax = false
      this.form.id = data.id
      this.form.type = data.type
      this.form.name = data.name
      this.form.competeStatusName = data.competeStatusName
      this.form.competeStatus = data.competeStatus
      this.form.ageStandard = data.ageStandard
      this.form.userCreatesTeam = data.userCreatesTeam
      this.form.paymentMethod = data.paymentMethod
      this.form.signUpAndChooseTeam = data.signUpAndChooseTeam
      this.form.startTime = data.startTime
      this.form.endTime = data.endTime
      this.form.enrollStartTime = data.enrollStartTime
      this.form.enrollEndTime = data.enrollEndTime
      this.startTime = this.onPickTime(data.startTime)
      this.enrollEndTime = this.onPickTime(data.enrollEndTime)
      this.form.singleFee = data.singleFee
      this.form.teamEnrollLowLimit = data.teamEnrollLowLimit
      this.form.teamEnrollUpLimit = data.teamEnrollUpLimit
      this.form.singleEnrollItemLimit = data.singleEnrollItemLimit
      this.form.competeItemDtoList = []
      for (let index = 0; index < data.competeItemDtoList.length; index++) {
        let str = {
          ageGroupId: data.competeItemDtoList[index].ageGroupId,
          competeCategoryId: data.competeItemDtoList[index].competeCategoryId,
          competeCategoryName: data.competeItemDtoList[index].competeCategoryName,
          competeItemListId: data.competeItemDtoList[index].competeItemListId,
          competeNumberId: data.competeItemDtoList[index].competeNumberId,
          competeNumberName: data.competeItemDtoList[index].competeNumberName,
          enrollLimit: data.competeItemDtoList[index].enrollLimit,
          enrollNum: data.competeItemDtoList[index].enrollNum,
          eventId: data.competeItemDtoList[index].eventId,
          groupId: data.competeItemDtoList[index].groupId,
          id: data.competeItemDtoList[index].id,
          itemAgeName: data.competeItemDtoList[index].itemAgeName,
          itemEventName: data.competeItemDtoList[index].itemEventName,
          itemGroupName: data.competeItemDtoList[index].itemGroupName,
          itemName: data.competeItemDtoList[index].itemName,
        }
        this.form.competeItemDtoList.push(str)
      }
      // 备份编辑-赛事项目数据
      this.form_competeItemDtoList_bak = JSON.parse(JSON.stringify(this.form.competeItemDtoList))
      this.form_competeItemDtoList_variable = JSON.parse(JSON.stringify(this.form.competeItemDtoList))
      this.form.imgUrl = data.imgUrl
      if (this.form.imgUrl !== '') {
        this.imgUrlMax = true
      }
      this.form.ruleUrlList = data.ruleUrlList
      if (this.form.ruleUrlList.length === 9) {
        this.ruleUrlsMax = true
      }
      this.form.certificateBackgroundUrl = data.certificateBackgroundUrl
      this.form.groupChatCode = data.groupChatCode !== undefined ? data.groupChatCode : ''
      console.log(this.codeUrlMax)
      if (this.form.certificateBackgroundUrl !== '') {
        this.bgUrlMax = true
      }
      if (this.form.groupChatCode !== '') {
        this.codeUrlMax = true
      }
      if (this.form.competeItemDtoList.length > 0) {
        this.hasItem = true
        this.textAddCompeteItem = this.$i18n.t('lang.btn_modifyCompeteItem')
      } else {
        this.hasItem = false
        this.textAddCompeteItem = this.$i18n.t('lang.btn_addCompeteItem')
      }
      // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
      this.saveData_form = JSON.stringify(this.form)
      this.changeData()
      this.isShow = true
    },
    // 查看
    onDetail(data) {
      console.log('onDetail', data)
      this.isTitle = this.$i18n.t('lang.btn_detail')
      this.isCase = 2
      this.form.id = data.id
      this.form.type = data.type
      this.form.name = data.name
      this.form.competeStatusName = data.competeStatusName
      this.form.competeStatus = data.competeStatus
      this.form.ageStandard = data.ageStandard
      this.form.startTime = data.startTime
      this.form.endTime = data.endTime
      this.form.userCreatesTeam = data.userCreatesTeam
      this.form.paymentMethod = data.paymentMethod
      this.form.signUpAndChooseTeam = data.signUpAndChooseTeam
      this.form.enrollStartTime = data.enrollStartTime
      this.form.enrollEndTime = data.enrollEndTime
      this.startTime = data.startTime
      this.enrollEndTime = data.enrollEndTime
      this.form.singleFee = data.singleFee
      this.form.teamEnrollLowLimit = data.teamEnrollLowLimit
      this.form.teamEnrollUpLimit = data.teamEnrollUpLimit
      this.form.singleEnrollItemLimit = data.singleEnrollItemLimit
      this.form.competeItemDtoList = []
      for (let index = 0; index < data.competeItemDtoList.length; index++) {
        let str = {
          ageGroupId: data.competeItemDtoList[index].ageGroupId,
          competeCategoryId: data.competeItemDtoList[index].competeCategoryId,
          competeCategoryName: data.competeItemDtoList[index].competeCategoryName,
          competeItemListId: data.competeItemDtoList[index].competeItemListId,
          competeNumberId: data.competeItemDtoList[index].competeNumberId,
          competeNumberName: data.competeItemDtoList[index].competeNumberName,
          enrollLimit: data.competeItemDtoList[index].enrollLimit,
          enrollNum: data.competeItemDtoList[index].enrollNum,
          eventId: data.competeItemDtoList[index].eventId,
          groupId: data.competeItemDtoList[index].groupId,
          id: data.competeItemDtoList[index].id,
          itemAgeName: data.competeItemDtoList[index].itemAgeName,
          itemEventName: data.competeItemDtoList[index].itemEventName,
          itemGroupName: data.competeItemDtoList[index].itemGroupName,
          itemName: data.competeItemDtoList[index].itemName,
        }
        this.form.competeItemDtoList.push(str)
      }
      this.form.imgUrl = data.imgUrl
      this.form.ruleUrlList = data.ruleUrlList
      this.form.certificateBackgroundUrl = data.certificateBackgroundUrl
      this.form.groupChatCode = data.groupChatCode ? data.groupChatCode : ''
      if (this.form.competeItemDtoList.length > 0) {
        this.hasItem = true
        this.textAddCompeteItem = this.$i18n.t('lang.btn_modifyCompeteItem')
      } else {
        this.hasItem = false
        this.textAddCompeteItem = this.$i18n.t('lang.btn_addCompeteItem')
      }
      this.changeData()
      this.isShow = true
    },
    // 数据转换
    changeData() {
      // 转换报名时间
      this.enrollValues = []
      if (this.form.enrollStartTime && this.form.enrollStartTime !== null && this.form.enrollEndTime && this.form.enrollEndTime !== null) {
        this.enrollValues[0] = this.form.enrollStartTime
        this.enrollValues[1] = this.form.enrollEndTime
        this.$set(this.enrollValues, 0, this.form.enrollStartTime)
        this.$set(this.enrollValues, 1, this.form.enrollEndTime)
      }
      this.saveData_enrollValues = JSON.stringify(this.enrollValues)
      // 转换比赛时间
      this.raceValues = []
      if (this.form.startTime && this.form.startTime !== null && this.form.endTime && this.form.endTime !== null) {
        this.raceValues[0] = this.form.startTime
        this.raceValues[1] = this.form.endTime
        this.$set(this.raceValues, 0, this.form.startTime)
        this.$set(this.raceValues, 1, this.form.endTime)
      }
      this.saveData_raceValues = JSON.stringify(this.raceValues)
      // 转换赛事封面
      this.imgUrlList = []
      if (this.form.imgUrl && this.form.imgUrl !== '') {
        this.imgUrlList.push({
          name: '',
          url: this.form.imgUrl.toString()
        })
        this.imgUrlArray.push(this.form.imgUrl.toString())
      }
      // 转换赛事规程
      this.ruleUrlsList = []
      if (this.form.ruleUrlList && this.form.ruleUrlList !== null) {
        for (let index = 0; index < this.form.ruleUrlList.length; index++) {
          let temp = this.form.ruleUrlList[index]
          this.ruleUrlsList.push({
            name: '',
            url: temp.toString()
          })
          this.ruleUrlArray.push(temp.toString())
        }
      }
      // 转换证书背景
      this.backgroundUrlList = []
      if (this.form.certificateBackgroundUrl && this.form.certificateBackgroundUrl !== null) {
        this.backgroundUrlList.push({
          name: '',
          url: this.form.certificateBackgroundUrl.toString()
        })
        this.backgroundUrlArray.push(this.form.certificateBackgroundUrl.toString())
      }
      // 群聊二维码
      this.groupChatCodeList = []
      if (this.form.groupChatCode && this.form.groupChatCode !== null) {
        this.groupChatCodeList.push({
          name: '',
          url: this.form.groupChatCode.toString()
        })
        this.backgroundUrlArray.push(this.form.groupChatCode.toString())
      }
    },
    // 删除赛事项目
    deleteOne(data) {
      console.log('deleteOne', data)
      this.$confirm(this.$i18n.t('lang.lab_isDelete'), this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
        console.log('yes')
        var index = this.form.competeItemDtoList.indexOf(data)
        if (index !== -1) {
          this.form.competeItemDtoList.splice(index, 1)
          let findme = this.form.competeItemDtoList.findIndex(item => item.competeItemListId === data.competeItemListId)
          console.log('findme', findme)
          if (findme !== -1) {
            this.form.competeItemDtoList.splice(findme, 1)
          }
          // 更新备份
          this.form_competeItemDtoList_variable = []
          this.form_competeItemDtoList_variable = JSON.parse(JSON.stringify(this.form.competeItemDtoList))
          console.log('deleteOne::form_competeItemDtoList_variable', this.form_competeItemDtoList_variable)
          if (this.form.competeItemDtoList.length > 0) {
            this.hasItem = true
            this.textAddCompeteItem = this.$i18n.t('lang.btn_modifyCompeteItem')
          } else {
            this.hasItem = false
            this.textAddCompeteItem = this.$i18n.t('lang.btn_addCompeteItem')
          }
          this.$message({
            type: 'success',
            message: this.$i18n.t('lang.lab_delSuccess')
          })
          this.$refs.cForm.clearValidate() // 移除校验结果
          // this.$refs['cForm'].resetFields() // 移除校验结果并重置字段值
          // this.$refs['cForm'].validate() // 校验
        }
      })
        .catch(() => {
          console.log('no')
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_delCancel')
          })
        })
    },
    // 选择报名时间
    onPickEnroll(dateRange) {
      console.log('onPickEnroll', dateRange)
      this.form.enrollStartTime = this.enrollValues[0]
      this.form.enrollEndTime = this.enrollValues[1]
      var date = new Date(this.form.enrollEndTime)
      var Y = date.getFullYear()
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
      var D = date.getDate() > 9 ? date.getDate() : ('0' + date.getDate())
      this.enrollEndTime = Y + '-' + M + '-' + D
      console.log('this.enrollEndTime', this.enrollEndTime)
    },
    // 选择比赛时间
    onPickRace(dateRange) {
      console.log('onPickRace', dateRange)
      this.form.startTime = this.raceValues[0]
      this.form.endTime = this.raceValues[1]
      var date = new Date(this.form.startTime)
      var Y = date.getFullYear()
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
      var D = date.getDate() > 9 ? date.getDate() : ('0' + date.getDate())
      this.startTime = Y + '-' + M + '-' + D
      console.log('this.startTime', this.startTime)
    },
    // 时间转换
    onPickTime(value) {
      var date = new Date(value)
      var Y = date.getFullYear()
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
      var D = date.getDate() > 9 ? date.getDate() : ('0' + date.getDate())
      return Y + '-' + M + '-' + D
    },
    // 添加/修改赛事项目
    toAddCompeteItem() {
      console.log('toAddCompeteItem')
      // this.onSearchCI(false, false)
      // this.getDataCI()
      this.newGetDataCI()
      this.getAgeList()
      this.getGroupList()
      this.getEventList()
      this.isShowCI = true
    },
    // 保存
    toSave(formName, cFormName) {
      console.log('toSave')
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$refs[cFormName].validate((valid) => {
            if (valid) {
              // 报名时间
              if (this.enrollValues != []) {
                this.form.enrollStartTime = this.enrollValues[0]
                this.form.enrollEndTime = this.enrollValues[1]
              }
              // 比赛时间
              if (this.enrollValues != []) {
                this.form.startTime = this.raceValues[0]
                this.form.endTime = this.raceValues[1]
              }
              let params = this.form
              this.$postJson('/compete/compete', params).then(
                res => {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_modifySuccess')
                  })
                  if (res && res.code === 200) {
                    this.isShow = false
                    // 更新列表
                    this.onSearch(true, false)
                  } else {
                    this.$message.error(res.message)
                  }
                },
                error => {
                  this.$message.error(error)
                }
              )
            } else {
              return false
            }
          })
        } else {
          if (this.form.competeItemDtoList.length > 0) {
            this.$refs[cFormName].validate((valid) => {
              if (valid) {
              } else {
                return false
              }
            })
          }
          return false
        }
      })
    },
    // 取消
    toCancel() {
      console.log('toCancel')
      this.isShow = false
      this.hasItem = false
      if (this.form.competeItemDtoList.length > 0) {
        this.$refs.cForm.clearValidate()
      }
      this.$refs.form.clearValidate()
      this.form.id = ''
      this.form.type = 0
      this.form.name = ''
      this.form.competeStatus = ''
      this.form.ageStandard = ''
      this.form.userCreatesTeam = 0
      this.form.paymentMethod = 0
      this.form.signUpAndChooseTeam = 1
      this.form.competeStatusName = ''
      this.form.startTime = ''
      this.form.endTime = ''
      this.form.enrollStartTime = ''
      this.form.enrollEndTime = ''
      this.startTime = ''
      this.enrollEndTime = ''
      this.form.singleFee = ''
      this.form.teamEnrollLowLimit = ''
      this.form.teamEnrollUpLimit = ''
      this.form.singleEnrollItemLimit = ''
      this.form.competeItemDtoList = []
      this.form.imgUrl = ''
      this.form.ruleUrlList = []
      this.form.certificateBackgroundUrl = ''
      this.form.groupChatCode = ''
      this.form_competeItemDtoList_bak = []
      this.form_competeItemDtoList_variable = []
    },
    // 进入场次管理页面
    linkSessions(id) {
      console.log('场次管理', id)
      this.$router.push({ name: 'sessions', query: { id: id } })
    },
    // 进入团队管理页面
    linkTeams(id) {
      console.log('团队管理', id)
      this.$router.push({ name: 'teams', query: { id: id } })
    },
    // 进入赛事项目页面
    linkProject(id) {
      console.log('赛事项目', id)
      // 重置赛事项目的pageSize和pageNum
      window.localStorage.setItem('competeItemPageSize', JSON.stringify(50))
      window.localStorage.setItem('competeItemPageNum', JSON.stringify(1))
      this.$router.push({ name: 'events', query: { id: id } })
    },
    // 进入选手列表页面
    linkPlayer(data) {
      console.log('选手列表', data.id)
      this.$router.push({ name: 'players', query: { id: data.id, competeName: data.name } })
    },
    // 监听表格排序
    changeTableSort(column) {
      console.log('排序', column)
      // 将排序传给后台
      this.sortName = column.order
      this.sortFieldName = column.prop
      this.onSearch(true, false)
    },
    // 监听关闭'新建编辑查看'dialog
    handleDialogClosed() {
      console.log('handleDialogClosed')
      this.isShow = false
      this.hasItem = false
      if (this.form.competeItemDtoList.length > 0) {
        this.$refs.cForm.clearValidate()
      }
      this.$refs.form.clearValidate()
      this.form.id = ''
      this.form.type = 0
      this.form.name = ''
      this.form.competeStatus = ''
      this.form.ageStandard = ''
      this.form.competeStatusName = ''
      this.form.startTime = ''
      this.form.endTime = ''
      this.form.enrollStartTime = ''
      this.form.enrollEndTime = ''
      this.form.userCreatesTeam = 0
      this.form.paymentMethod = 0
      this.form.signUpAndChooseTeam = 1
      this.startTime = ''
      this.enrollEndTime = ''
      this.form.singleFee = ''
      this.form.teamEnrollLowLimit = ''
      this.form.teamEnrollUpLimit = ''
      this.form.singleEnrollItemLimit = ''
      this.form.competeItemDtoList = []
      this.form.imgUrl = ''
      this.form.ruleUrlList = []
      this.form.certificateBackgroundUrl = ''
      this.form.groupChatCode = ''
      this.enrollValues = []
      this.raceValues = []
      this.imgUrlList = []
      this.ruleUrlsList = []
      this.backgroundUrlList = []
      this.groupChatCodeList = []
      this.form_competeItemDtoList_bak = []
      this.form_competeItemDtoList_variable = []
      // 关闭“新建/编辑”赛事弹窗时，清除“赛事项目”的筛选、搜索、翻页条件。
      this.onNewClearCI()
    },
    // 监听关闭'添加赛事项目'dialog
    handleDialogClosedCI() {
      console.log('handleDialogClosedCI')
      this.isShowCI = false
    },
    // 翻页 
    handleCurrentChange(val) {
      this.pageNum = val
      this.onSearch(false, false)
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.onSearch(false, false)
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 多选框
    handleSelectionChange(val) {
      console.log('多选', val)
      this.multipleSelection = val
    },
    // 上传数量超过提醒
    outlimit() {
      this.$message.warning(this.$i18n.t('lang.warning_uploadLimit'))
    },
    // 赛事封面上传
    handleSuccessImg(response, file, fileList) {
      console.log('Upload Success Img!', file, fileList)
      this.imgUrlMax = true
      this.form.imgUrl = file.response.data[0]
      this.imgUrlList[0] = file.response.data[0]
      this.$refs.imgUrl.clearValidate()
    },
    // 赛事封面删除
    handleRemoveImg(file, fileList) {
      console.log('handleRemoveImge!', file, fileList)
      this.imgUrlList = fileList
      this.form.imgUrl = ''
      this.imgUrlMax = false
    },
    // 赛事规程上传
    handleSuccessRule(response, file, fileList) {
      console.log('Upload Success Rule!', file, fileList)
      if (fileList.length === 9) {
        this.ruleUrlsMax = true
      } else {
        this.ruleUrlsMax = false
      }
      this.ruleUrlsList = fileList
      if (this.ruleUrlsList.length > 0) {
        this.form.ruleUrlList = []
        for (let index = 0; index < this.ruleUrlsList.length; index++) {
          // 新上传的
          if (this.ruleUrlsList[index].response) {
            this.form.ruleUrlList.push(this.ruleUrlsList[index].response.data[0])
          } else { // 原图片
            this.form.ruleUrlList.push(this.ruleUrlsList[index].url
            )
          }
        }
        this.$refs.ruleUrlList.clearValidate()
      }
    },
    // 赛事规程删除
    handleRemoveRule(file, fileList) {
      console.log('handleRemoveRule!', file, fileList)
      this.ruleUrlsList = fileList
      if (this.ruleUrlsList.length > 0) {
        this.form.ruleUrlList = []
        for (let index = 0; index < this.ruleUrlsList.length; index++) {
          // this.form.ruleUrlList.push(this.ruleUrlsList[index].response.data[0])
          // 新上传的
          if (this.ruleUrlsList[index].response) {
            this.form.ruleUrlList.push(this.ruleUrlsList[index].response.data[0])
          } else { // 原图片
            this.form.ruleUrlList.push(this.ruleUrlsList[index].url
            )
          }
        }
      } else {
        this.form.ruleUrlList = []
      }
      this.ruleUrlsMax = false
      console.log(this.form.ruleUrlList)
    },
     //  群聊二维码上传
     handleSuccessCode(response, file, fileList) {
      console.log('handleSuccessCode!', file, fileList)
      this.codeUrlMax = true
      this.form.groupChatCode = file.response.data[0]
      this.groupChatCodeList[0] = file.response.data[0]
      this.$refs.groupChatCode.clearValidate()
    },
      // 群聊二维码删除
      handleRemoveCode(file, fileList) {
      console.log('handleRemoveCode!')
      this.groupChatCodeList = fileList
      this.form.groupChatCode = ''
      this.codeUrlMax = false
    },
    // 证书背景上传
    handleSuccessBg(response, file, fileList) {
      console.log('Upload Success Bg!', file, fileList)
      this.bgUrlMax = true
      this.form.certificateBackgroundUrl = file.response.data[0]
      this.backgroundUrlList[0] = file.response.data[0]
      this.$refs.certificateBackgroundUrl.clearValidate()
    },
    // 证书背景删除
    handleRemoveBg(file, fileList) {
      console.log('handleRemoveBg!')
      this.backgroundUrlList = fileList
      this.form.certificateBackgroundUrl = ''
      this.bgUrlMax = false
    },
    // 上传文件的断网
    uploadErr() {
      if (!navigator.onLine || window.navigator.onLine === false) {
        const loading = this.$loading()
        setTimeout(() => {
          loading.close()
          this.$message.error(this.$i18n.t('lang.warning_network'))
        }, 500)
      }
    },
    // 单人单项费用 输入限制
    keySingleFee() {
      // 仅保留数字和"."
      this.form.singleFee = this.form.singleFee.replace(/[^\d.]/g, '')
      // 两个连续的"."仅保留第一个"."
      this.form.singleFee = this.form.singleFee.replace(/\.{2,}/g, '.')
      // 去除其他"."
      this.form.singleFee = this.form.singleFee.replace('.', '$#*').replace(/\./g, '').replace('$#*', '.')
      // 限制只能输入两个小数
      this.form.singleFee = this.form.singleFee.replace(/^(\d+)\.(\d\d).*$/, '$1.$2')
      // 首位是0的话去掉
      if (this.form.singleFee.indexOf('.') < 0 && this.form.singleFee !== '') {
        this.form.singleFee = parseFloat(this.form.singleFee)
      }
    },
    // 团队报名人数下限 输入限制
    keyTeamLow() {
      // 仅保留数字
      this.form.teamEnrollLowLimit = this.form.teamEnrollLowLimit.replace(/[^\d]/g, '')
      // 首位是0的话去掉
      if (this.form.teamEnrollLowLimit.indexOf('.') < 0 && this.form.teamEnrollLowLimit !== '') {
        this.form.teamEnrollLowLimit = parseFloat(this.form.teamEnrollLowLimit)
      }
    },
    // 团队报名人数上限 输入限制
    keyTeamHigh() {
      // 仅保留数字
      this.form.teamEnrollUpLimit = this.form.teamEnrollUpLimit.replace(/[^\d]/g, '')
      // 首位是0的话去掉
      if (this.form.teamEnrollUpLimit.indexOf('.') < 0 && this.form.teamEnrollUpLimit !== '') {
        this.form.teamEnrollUpLimit = parseFloat(this.form.teamEnrollUpLimit)
      }
    },
    // 单人报名项目上限 输入限制
    keySingleEnroll() {
      // 仅保留数字
      this.form.singleEnrollItemLimit = this.form.singleEnrollItemLimit.replace(/[^\d]/g, '')
      // 首位是0的话去掉
      if (this.form.singleEnrollItemLimit.indexOf('.') < 0 && this.form.singleEnrollItemLimit !== '') {
        this.form.singleEnrollItemLimit = parseFloat(this.form.singleEnrollItemLimit)
      }
    },
    // 报名上限
    keyEnrollLimit() {
      for (var x = 0; x < this.form.competeItemDtoList.length; x++) {
        // 仅保留数字
        var temp = this.form.competeItemDtoList[x].enrollLimit
        temp = String(temp)
        this.form.competeItemDtoList[x].enrollLimit = temp.replace(/[^\d]/g, '')
        // 首位是0的话去掉
        if (this.form.competeItemDtoList[x].enrollLimit.indexOf('.') < 0 && this.form.competeItemDtoList[x].enrollLimit != '') {
          this.form.competeItemDtoList[x].enrollLimit = parseFloat(this.form.competeItemDtoList[x].enrollLimit)
        }
      }
    },
    // 获取赛事项目列表数据
    getDataCI() {
      // 更新备份
      this.form_competeItemDtoList_variable = []
      this.form_competeItemDtoList_variable = JSON.parse(JSON.stringify(this.form.competeItemDtoList))
      console.log('getDataCI::form_competeItemDtoList_variable', this.form_competeItemDtoList_variable)
      // 保证数组一致
      this.multipleSelectionCI = []
      this.multipleSelectionCI = JSON.parse(JSON.stringify(this.form.competeItemDtoList))
      let params = {
        pageNum: this.pageNumCI,
        pageSize: this.pageSizeCI
      }
      this.$postJson('/item/all/filterItem', params).then(
        res => {
          if (res && res.code === 200) {
            this.totalCI = res.data.total
            this.tableDataCI = res.data.list
            // 编辑页面已有的赛事项目需要默认check状态
            var that = this
            that.$nextTick(() => {
              if (that.$refs.multipleTableCI) {
                that.$refs.multipleTableCI.clearSelection()
              }
              that.tableDataCI.forEach(row => {
                for (let j in that.form.competeItemDtoList) {
                  if (row.competeItemListId === that.form.competeItemDtoList[j].competeItemListId) {
                    console.log('check', row.itemName)
                    that.$refs.multipleTableCI.toggleRowSelection(row, true)
                  }
                }
              })
            })
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 获取年龄段下拉list
    getAgeList() {
      this.$get('/itemAge/itemAge').then(
        res => {
          if (res && res.code === 200) {
            this.ageNames = res.data.list
            // let newValue = {
            //   id: '',
            //   ageGroupName: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_competeAgeGroup')
            // }
            // this.ageNames.unshift(newValue)   
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 获取组别下拉list
    getGroupList() {
      this.$get('/itemGroup/itemGroup').then(
        res => {
          if (res && res.code === 200) {
            this.groupNames = res.data.list
            // let newValue = {
            //   id: '',
            //   groupName: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_competeGroup')
            // }
            // this.groupNames.unshift(newValue)     
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 获取比赛项下拉list
    getEventList() {
      this.$get('/itemEvent/itemEvent').then(
        res => {
          if (res && res.code === 200) {
            this.eventNames = res.data.list
            // let newValue = {
            //   id: '',
            //   eventName: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_competeEvent')
            // }
            // this.eventNames.unshift(newValue)   
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 赛事项目-查询
    onSearchCI(flag, isSearchCI) {
      if (flag) {
        this.pageNumCI = 1
      }
      if (isSearchCI) {
        // 记忆筛选项值
        this.itemName_bak = this.itemName
        this.eventId_bak = this.eventId
        this.groupId_bak = this.groupId
        this.ageGroupId_bak = this.ageGroupId
      } else {
        // 筛选项正确显示
        this.itemName = this.itemName_bak
        this.eventId = this.eventId_bak
        this.groupId = this.groupId_bak
        this.ageGroupId = this.ageGroupId_bak
      }
      let params = {
        itemName: this.itemName,
        eventIds: this.eventId,
        groupIds: this.groupId,
        ageGroupIds: this.ageGroupId,
        sortName: this.sortNameCI,
        sortFieldName: this.sortFieldNameCI,
        pageNum: this.pageNumCI,
        pageSize: this.pageSizeCI
      }
      this.$postJson('/item/all/filterItem', params).then(
        res => {
          if (res && res.code === 200) {
            this.totalCI = res.data.total
            this.tableDataCI = res.data.list
            // 编辑页面已有的赛事项目需要默认check状态
            var that = this
            that.$nextTick(() => {
              that.tableDataCI.forEach(row => {
                for (let j in that.multipleSelectionCI) {
                  if (row.competeItemListId === that.multipleSelectionCI[j].competeItemListId) {
                    console.log('check', row.itemName)
                    that.$refs.multipleTableCI.toggleRowSelection(row, true)
                  }
                }
              })
            })
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // newgetDataCI
    newGetDataCI() {
      // 筛选项正确显示
      this.itemName = this.itemName_bak
      this.eventId = this.eventId_bak
      this.groupId = this.groupId_bak
      this.ageGroupId = this.ageGroupId_bak
      // 更新备份
      this.form_competeItemDtoList_variable = []
      this.form_competeItemDtoList_variable = JSON.parse(JSON.stringify(this.form.competeItemDtoList))
      console.log('getDataCI::form_competeItemDtoList_variable', this.form_competeItemDtoList_variable)
      // 保证数组一致
      this.multipleSelectionCI = []
      this.multipleSelectionCI = JSON.parse(JSON.stringify(this.form.competeItemDtoList))
      let params = {
        itemName: this.itemName,
        eventIds: this.eventId,
        groupIds: this.groupId,
        ageGroupIds: this.ageGroupId,
        sortName: this.sortNameCI,
        sortFieldName: this.sortFieldNameCI,
        pageNum: this.pageNumCI,
        pageSize: this.pageSizeCI
      }
      this.$postJson('/item/all/filterItem', params).then(
        res => {
          if (res && res.code === 200) {
            this.totalCI = res.data.total
            this.tableDataCI = res.data.list
            // 编辑页面已有的赛事项目需要默认check状态
            var that = this
            that.$nextTick(() => {
              if (that.$refs.multipleTableCI) {
                that.$refs.multipleTableCI.clearSelection()
              }
              that.tableDataCI.forEach(row => {
                for (let j in that.form.competeItemDtoList) {
                  if (row.competeItemListId === that.form.competeItemDtoList[j].competeItemListId) {
                    console.log('check', row.itemName)
                    that.$refs.multipleTableCI.toggleRowSelection(row, true)
                  }
                }
              })
            })
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 赛事项目-重置
    onClearCI() {
      this.itemName = ''
      this.eventId = []
      this.groupId = []
      this.ageGroupId = []
      this.itemName_bak = ''
      this.eventId_bak = []
      this.groupId_bak = []
      this.ageGroupId_bak = []
      this.sortNameCI = ''
      this.sortFieldNameCI = ''
      this.pageNumCI = 1
      this.getDataCI()
    },
    // 赛事项目-重置
    onNewClearCI() {
      this.itemName = ''
      this.eventId = []
      this.groupId = []
      this.ageGroupId = []
      this.itemName_bak = ''
      this.eventId_bak = []
      this.groupId_bak = []
      this.ageGroupId_bak = []
      this.sortNameCI = ''
      this.sortFieldNameCI = ''
      this.pageNumCI = 1
    },
    // 赛事项目-确定添加到赛事
    onConfirmCI() {
      console.log('onConfirmCI')
      console.log('onConfirmCI1::form_competeItemDtoList_variable', this.form_competeItemDtoList_variable)
      // 最新赛事项目list
      this.form.competeItemDtoList = []
      for (let index = 0; index < this.multipleSelectionCI.length; index++) {
        var tempMultipleSelectionCI = JSON.parse(JSON.stringify(this.multipleSelectionCI[index]))
        tempMultipleSelectionCI.id = ''
        this.form.competeItemDtoList.push(tempMultipleSelectionCI)
      }
      // 查找备份中有但list没有的项
      for (let index = 0; index < this.form_competeItemDtoList_variable.length; index++) {
        let findme = this.form.competeItemDtoList.findIndex(item => item.competeItemListId === this.form_competeItemDtoList_variable[index].competeItemListId)
        if (findme === -1) {
          console.log('this.form_competeItemDtoList_variable[', index, '].enrollNum', this.form_competeItemDtoList_variable[index].enrollNum)
          if (this.form_competeItemDtoList_variable[index].enrollNum > 0) {
            this.form.competeItemDtoList.push(this.form_competeItemDtoList_variable[index])
            this.$message.warning(this.$i18n.t('lang.warning_enrollNum'))
          }
        } else {
          this.form.competeItemDtoList[findme].id = this.form_competeItemDtoList_variable[index].id
          this.form.competeItemDtoList[findme].enrollNum = this.form_competeItemDtoList_variable[index].enrollNum
          this.form.competeItemDtoList[findme].ageGroupId = this.form_competeItemDtoList_variable[index].ageGroupId
          this.form.competeItemDtoList[findme].competeCategoryId = this.form_competeItemDtoList_variable[index].competeCategoryId
          this.form.competeItemDtoList[findme].competeCategoryName = this.form_competeItemDtoList_variable[index].competeCategoryName
          this.form.competeItemDtoList[findme].competeItemListId = this.form_competeItemDtoList_variable[index].competeItemListId
          this.form.competeItemDtoList[findme].competeNumberId = this.form_competeItemDtoList_variable[index].competeNumberId
          this.form.competeItemDtoList[findme].competeNumberName = this.form_competeItemDtoList_variable[index].competeNumberName
          this.form.competeItemDtoList[findme].enrollLimit = this.form_competeItemDtoList_variable[index].enrollLimit
          this.form.competeItemDtoList[findme].eventId = this.form_competeItemDtoList_variable[index].eventId
          this.form.competeItemDtoList[findme].groupId = this.form_competeItemDtoList_variable[index].groupId
          this.form.competeItemDtoList[findme].itemAgeName = this.form_competeItemDtoList_variable[index].itemAgeName
          this.form.competeItemDtoList[findme].itemEventName = this.form_competeItemDtoList_variable[index].itemEventName
          this.form.competeItemDtoList[findme].itemGroupName = this.form_competeItemDtoList_variable[index].itemGroupName
          this.form.competeItemDtoList[findme].itemName = this.form_competeItemDtoList_variable[index].itemName
        }
      }
      // list中是否包含初始数据
      for (let index = 0; index < this.form_competeItemDtoList_bak.length; index++) {
        let findme = this.form.competeItemDtoList.findIndex(item => item.competeItemListId === this.form_competeItemDtoList_bak[index].competeItemListId)
        if (findme !== -1) {
          this.form.competeItemDtoList[findme].id = this.form_competeItemDtoList_bak[index].id
          this.form.competeItemDtoList[findme].enrollNum = this.form_competeItemDtoList_bak[index].enrollNum
          this.form.competeItemDtoList[findme].ageGroupId = this.form_competeItemDtoList_bak[index].ageGroupId
          this.form.competeItemDtoList[findme].competeCategoryId = this.form_competeItemDtoList_bak[index].competeCategoryId
          this.form.competeItemDtoList[findme].competeCategoryName = this.form_competeItemDtoList_bak[index].competeCategoryName
          this.form.competeItemDtoList[findme].competeItemListId = this.form_competeItemDtoList_bak[index].competeItemListId
          this.form.competeItemDtoList[findme].competeNumberId = this.form_competeItemDtoList_bak[index].competeNumberId
          this.form.competeItemDtoList[findme].competeNumberName = this.form_competeItemDtoList_bak[index].competeNumberName
          this.form.competeItemDtoList[findme].enrollLimit = this.form_competeItemDtoList_bak[index].enrollLimit
          this.form.competeItemDtoList[findme].eventId = this.form_competeItemDtoList_bak[index].eventId
          this.form.competeItemDtoList[findme].groupId = this.form_competeItemDtoList_bak[index].groupId
          this.form.competeItemDtoList[findme].itemAgeName = this.form_competeItemDtoList_bak[index].itemAgeName
          this.form.competeItemDtoList[findme].itemEventName = this.form_competeItemDtoList_bak[index].itemEventName
          this.form.competeItemDtoList[findme].itemGroupName = this.form_competeItemDtoList_bak[index].itemGroupName
          this.form.competeItemDtoList[findme].itemName = this.form_competeItemDtoList_bak[index].itemName
        }
      }
      // 更新备份
      this.form_competeItemDtoList_variable = []
      this.form_competeItemDtoList_variable = JSON.parse(JSON.stringify(this.form.competeItemDtoList))
      console.log('onConfirmCI2::form_competeItemDtoList_variable', this.form_competeItemDtoList_variable)
      // 修改状态
      if (this.form.competeItemDtoList.length > 0) {
        this.hasItem = true
        this.textAddCompeteItem = this.$i18n.t('lang.btn_modifyCompeteItem')
        this.$refs.competeItemDtoList.clearValidate() // 移除校验结果
      } else {
        this.hasItem = false
        this.textAddCompeteItem = this.$i18n.t('lang.btn_addCompeteItem')
      }
      console.log('确定添加到赛事', this.form.competeItemDtoList)
      this.isShowCI = false
    },
    // 赛事项目列表 翻页
    handleCurrentChangeCI(val) {
      this.pageNumCI = val
      this.onSearchCI(false, false)
    },
    // 赛事项目列表 切换每页显示多少数据
    handleSizeChangeCI(val) {
      this.pageNumCI = 1
      this.pageSizeCI = val
      this.onSearchCI(false, false)
    },
    // 赛事项目列表 表格斑马
    tableRowClassNameCI({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 赛事项目列表 多选框
    handleSelectionChangeCI(val) {
      // console.log('赛事项目列表 多选', val)
      // this.multipleSelectionCI = val
    },
    // 赛事项目列表 多选框-单选
    handleSelectionCI(selection, row) {
      console.log('赛事项目列表 单选', selection, row)
      let index = this.multipleSelectionCI.findIndex(item => item.competeItemListId === row.competeItemListId)
      if (index === -1) {
        this.multipleSelectionCI.push(row)
      } else {
        this.multipleSelectionCI.splice(index, 1)
      }
    },
    // 赛事项目列表 多选框-全选
    handleSelectAllCI(selection) {
      console.log('赛事项目列表 全选', selection)
      if (selection.length > 0) {
        this.multipleSelectionCI = this.multipleSelectionCI.concat(selection)
        const arr = this.multipleSelectionCI
        var array = []
        for (let i = 0; i < arr.length; i++) {
          let index = array.findIndex(item => item.competeItemListId === arr[i].competeItemListId)
          if (index === -1) {
            array.push(arr[i])
          }
        }
        this.multipleSelectionCI = array
      } else {
        for (let j = 0; j < this.tableDataCI.length; j++) {
          let index = this.multipleSelectionCI.findIndex(item => item.competeItemListId === this.tableDataCI[j].competeItemListId)
          if (index !== -1) {
            this.multipleSelectionCI.splice(index, 1)
          }
        }
      }
    },
    // 赛事项目列表 row-key
    getRowKey(row) {
      return row.id
    },
    // 赛事项目列表 监听表格排序
    changeTableSortCI(column) {
      console.log('排序', column)
      // 将排序传给后台
      this.sortNameCI = column.order
      this.sortFieldNameCI = column.prop
      this.onSearchCI(true, false)
    },
    // 重置赛事项目数据（缓存）
    setDataeventsListLoacal() {
      var eventsListParam = {
        pageNum: 1,
        pageSize: 50,
        itemName: '',
        eventId: '',
        groupId: '',
        ageGroupId: '',
        sortName: '',
        sortFieldName: '',
      }
      window.localStorage.setItem('eventsListParam', JSON.stringify(eventsListParam))
    },
  },
  created() {
    this.getData()
    // 重置赛事项目数据（缓存）
    this.setDataeventsListLoacal()
  },
  mounted() { },
  destroyed() {
    // 是否重置搜索项：如果tab不是offline，说明跳转别的tab，需要重置--1；如果是offline，说明进入了详情，保存搜索项和页码---0
    var clearRefresh = JSON.parse(window.localStorage.getItem('tabsValue')) !== 'offline' ? 1 : 0
    if (clearRefresh == 1) {
      this.name = ''
      this.state = ''
      this.pageNum = 1
      this.pageSize = 10
      this.sortName = ''
      this.sortFieldName = ''
      this.setDataLoacal()
    }
  }
}
</script>

<style lang='scss'>
.offlineList {
  .center-style {
    width: 100%;
    text-align: center;
    margin: 0 auto;
  }

  .img-style {
    width: 200px;
    height: 150px;
    border: 1px solid lightgray;
    border-radius: 5px;
    padding: 5px;
    margin-right: 20px;
  }

  .img-style-mini {
    width: 100px;
    height: 75px;
    border: 1px solid lightgray;
    border-radius: 5px;
    padding: 5px;
    margin-right: 20px;
  }

  .margin-r20 {
    margin-right: 20px;
  }

  .margin-t10 {
    margin-top: 10px;
  }

  .table-position {
    .el-table__header {
      width: 100% !important;
    }

    .el-table__empty-block {
      width: 100% !important;
    }

    .el-table__body {
      width: 100% !important;
    }
  }

  .deleteBtn-style {
    float: right;
    vertical-align: middle;
  }

  .confirmBtn-style {
    margin-top: 20px;
  }

  .dialog-style {
    .el-dialog .el-form .el-form-item {
      margin-right: 20px;
    }
  }

  .imgUrlDisabled {
    .el-upload--picture-card {
      display: none !important;
    }

    .el-button--small {
      display: none !important;
    }
  }

  .ruleUrlsDisabled {
    .el-upload--picture-card {
      display: none !important;
    }

    .el-button--small {
      display: none !important;
    }
  }

  .bgUrlDisabled {
    .el-upload--picture-card {
      display: none !important;
    }

    .el-button--small {
      display: none !important;
    }
  }
  .codeUrlDisabled{
    .el-upload--picture-card {
        display: none !important;
      }

      .el-button--small {
        display: none !important;
      }
  }
  .filtersCI {
    background: #fff;
    border-radius: 6px;
    margin-bottom: 20px;
    padding: 20px 0px 20px 20px;
    box-shadow: 0 4px 8px 0 #eaeaea;
    text-align: left; // IE中居左显示
  }

  // 添加赛事项目弹框-比赛项多选框样式
  .event-select {
    width: 375px !important;
  }
}
</style>
